import { TreeSapFlow, TreeSapGroup, TreeSapProcessNode } from '../../types';


export interface DataProcessingContextState {
  treeData: TreeSapGroup[];
  expandedIds: string[];
  sapSettingsPanelItem: TreeSapGroup | TreeSapFlow | TreeSapProcessNode;
  sapSettingsPanelOpen: boolean;
  sapInfoPanelItem: TreeSapGroup | TreeSapFlow | TreeSapProcessNode;
  sapInfoPanelOpen: boolean;
  creatingGroup: boolean;
  selectedSapItems: (TreeSapGroup | TreeSapFlow)[];
  selectedSapItemsPath: string[];
  selectedTreeData: (TreeSapGroup | TreeSapFlow | TreeSapProcessNode)[];
  somethingSelected: boolean;
}

export const initialState: DataProcessingContextState = {
  treeData: [],
  expandedIds: [],
  sapSettingsPanelItem: null,
  sapSettingsPanelOpen: false,
  sapInfoPanelItem: null,
  sapInfoPanelOpen: false,
  creatingGroup: false,
  selectedSapItems: [],
  selectedSapItemsPath: [],
  selectedTreeData: [],
  somethingSelected: false,
};
